import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { MainContextState, MainContext } from "../../../../context/MainContext";
import { ReportTableCreator } from "./ReportTableCreator";
import { form6Rows, form6HeaderRows } from "../helpers/form6";

interface IProps {
    editForm?: boolean;
}

export const Form6EditForm = ({ editForm = false }: IProps) => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    return (
        <>
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                    Форма 6
                </Typography>
            </Box>
            <ReportTableCreator bodyCell={form6Rows} header={form6HeaderRows} />
        </>
    );
};
